import React from 'react';

const licenseConfig = {
	settings: {
		style: 'layout1',
		layout: {
			config: {
				needUserInfo: true,
				redirectOn401: true,
				footer: {
					display: true
				}
			}
		}
	},
	routes: [
		{
			path: '/buy-license/:licenseId/:licensePlanId',
			component: React.lazy(() => import('./BuyLicenseV2'))
		},
		{
			path: '/license-archive',
			component: React.lazy(() => import('./license-archive'))
		}
	]
};

export default licenseConfig;
